var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-img',{attrs:{"src":_vm.logo,"width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }